export default "__VITE_ASSET__BRxHjHNc__"